__webpack_require__.p = "/speeches-rama9-atMU/";